exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".backlink[data-v-69b59b46]{color:#008bd0;font-size:12px;font-family:ClanPro;margin-top:20px;margin-bottom:50px;display:block;width:100%}.backlink.white[data-v-69b59b46]{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69b59b46","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Global/BackLink.vue
// module id = 924
// module chunks = 0